import theme from '@/theme';
import { semanticColors } from '@/theme/tokens';
import { CSSProperties } from 'react';

export function getPageLoaderStyles() {
  return {
    overlay: {
      position: 'fixed' as const,
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: semanticColors.overlay,
      zIndex: 9999,
    } as CSSProperties,
    loader: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 16,
    } as CSSProperties,
    statusText: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '1.1rem',
    },
  };
}
